'use strict'

import { apiInstance, legacyV2 } from './index'
import { mapArgs } from 'utils/functions'

const generic = {
  genericGet (endpoint, ...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/${endpoint}`,
      params
    })
  }
}

export default generic
